import {
  FETCH_STREAMS_SUCCESS,
  FETCH_STREAMS_FAILED,
  CLEAR_STREAMS
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STREAMS_SUCCESS:
      return {
        ...state,
        status: 'fetch_success',
        message: action.message,
        results: action.results,
      };
    case FETCH_STREAMS_FAILED:
      return { ...state, status: 'fetch_error', error: action.error };
    case CLEAR_STREAMS:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
